import * as React from "react";
import PropTypes from "prop-types";

export default function Error({ error }) {
  if (error) {
    return <p className="ms-fontColor-error">{error}</p>;
  }
  return null;
}

Error.propTypes = {
  error: PropTypes.string,
};
